var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.matchingTip)?_c('div',{staticClass:"px-matching-interest__tip"},[_c('PxIcon',{staticClass:"px-matching-interest__tipIcon",attrs:{"size":14,"name":"star--yellow"}}),_vm._v(" "+_vm._s(_vm.matchingTip)+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }